import { BASE_API_URL } from '../consts/base-url';
import customFetch from './fetch';
const isGcsUrl = (url: string) => {
  return url.startsWith('gs://');
};
export const getSignedUrl = async (url: string) => {
  if (!isGcsUrl(url)) {
    return url;
  }
  try {
    const response = await customFetch(`${BASE_API_URL}/reference`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        url
      })
    });
    if (!response.ok) {
      throw new Error('Failed to get signed url');
    }
    const {
      signedUrl
    } = await response.json();
    return signedUrl;
  } catch (error) {
    // TODO: Handle errors
    console.error('Error getting signed url:', error);
    throw error;
  }
};
export const replaceGcsUrlWithSignedUrl = async <T,>(payload: T): Promise<T> => {
  if (typeof payload === 'string' && isGcsUrl(payload)) {
    return (await getSignedUrl(payload) as T);
  }
  if (typeof payload !== 'object' || payload === null) {
    return payload;
  }
  if (Array.isArray(payload)) {
    const processedArrayPromises = payload.map(item => replaceGcsUrlWithSignedUrl(item));
    const resolvedArray = await Promise.all(processedArrayPromises);
    return ((resolvedArray as unknown) as T);
  }
  const result = ({
    ...payload
  } as Record<string, any>);
  const keys = Object.keys(result);
  const promises: Promise<void>[] = [];
  for (const key of keys) {
    const value = result[key];
    if (typeof value === 'string' && isGcsUrl(value)) {
      const promise = getSignedUrl(value).then(signedUrl => {
        result[key] = signedUrl;
      }).catch(error => {
        // TODO: Handle errors
        console.error(`Failed to get signed URL for ${value} (key: ${key}):`, error);
        throw error;
      });
      promises.push(promise);
    } else if (typeof value === 'object' && value !== null) {
      const promise = replaceGcsUrlWithSignedUrl(value).then(processedValue => {
        result[key] = processedValue;
      }).catch(error => {
        // TODO: Handle errors
        console.error(`Error processing nested object for key ${key}:`, error);
        throw error;
      });
      promises.push(promise);
    }
  }
  await Promise.all(promises);
  return (result as T);
};